<template>
  <div class="container">
    <h3>APP Privacy Policy - {{obj.name}}</h3>
    <div class="head">For technical support, please contact: {{ obj.email }}</div>

    <div class="head">I. Introduction</div>
    <div class="body">We respect the privacy of our users and are committed to safeguarding the personal information collected through our APP. This Privacy Policy outlines our practices regarding the collection, use, storage, and disclosure of personal information when you use our APP available on the Google Play Store.</div>
  
    <div class="head">II. Collection of Personal Information</div>
    <div class="body">
      1.Voluntary Information: When you use our APP, you may be prompted to provide personal information such as your name, email address, phone number, and other relevant details. This information is collected when you voluntarily submit it through various features or functionalities of the APP.<br>
      2.Automatic Collection: Our APP may automatically collect certain non-personal information about your device and usage patterns, including but not limited to device model, operating system, IP address, browser type, and usage statistics. This information helps us understand how our APP is being used and to improve its performance.<br>
      3.Others:In this app, we need to obtain the network usage rights of the phone, as well as some advertising usage rights.
    </div>
  
    <div class="head">III. Use of Personal Information</div>
    <div class="body">
      We use the personal information collected through our APP for the following purposes:<br>
      1.To provide you with the requested services and features of our APP.<br>
      2.To communicate with you, including responding to your inquiries, providing updates, and sending promotional messages (subject to your preferences).<br>
      3.To personalize your experience by customizing the content and features of our APP based on your preferences and usage patterns.<br>
      4.To improve our APP by analyzing user behavior and feedback.<br>
      5.To comply with legal obligations and respond to lawful requests from government authorities.
    </div>
  
    <div class="head">IV. Sharing of Personal Information</div>
    <div class="body">
      We may share personal information with third parties in the following circumstances:<br>
      1.With service providers who perform functions on our behalf, such as hosting, data analysis, and payment processing. These service providers are contractually obligated to keep your information secure and confidential.<br>
      2.If required by law or in response to a subpoena, court order, or other legal process.<br>
      3.In the event of a merger, acquisition, or sale of assets, personal information may be transferred as part of the transaction.
    </div>

    <div class="head">V. Security of Personal Information</div>
    <div class="body">
      We employ reasonable security measures to protect the confidentiality and integrity of personal information collected through our APP. 
    </div>

    <div class="head">VI. User Rights and Choices</div>
    <div class="body">
      You have the right to:<br>
      1.Request access to, correction, or deletion of your personal information.<br>
      2.Withdraw your consent to the collection, use, and sharing of your personal information at any time, subject to legal and contractual restrictions.<br>
      3.Opt-out of receiving promotional communications from us.
    </div>
  
    <div class="head">VII. Updates to Privacy Policy</div>
    <div class="body">
      We reserve the right to update this Privacy Policy at any time to reflect changes in our practices or legal requirements. Updated versions of the Privacy Policy will be posted on our APP. Your continued use of our APP after any such changes constitutes your acceptance of the revised Privacy Policy.
    </div>

    <div class="head">VIII. Contact Information</div>
    <div class="body">
      If you have any questions or concerns regarding this Privacy Policy, please contact us at {{ obj.email }}.
    </div>

    <div class="head">IX. Governing Law</div>
    <div class="body" style="margin-bottom: 40px;">
      This Privacy Policy is governed by the laws of the relevant country or region. Any disputes arising from this Privacy Policy shall be subject to the jurisdiction of the courts of the relevant country or region.
By downloading, installing, and using our APP on the Google Play Store, you acknowledge that you have read, understood, and agreed to the terms of this Privacy Policy. 
    </div>
  
  </div>
</template>

<script>

import { privacyPolicyText } from '@/kv777';

export default {
  components: {},

  data() {
      return {
        text: privacyPolicyText, 
        obj: {},
      };
  },
  
  mounted() {
    this.getConfig();
    // this.obj = gameName.objs[gameName.key];
    // console.log(this.obj);
  },

  methods:{
    async getConfig (){
        try {
        const response = await fetch('/config.json');
        if (!response.ok) {
          throw new Error('Network response was not ok: ' + response.statusText);
        }
        const data = await response.json();
        this.obj = data;
      } catch (error) {
        console.error('Error loading JSON file:', error);
        this.obj = {}; // 或者设置一个默认对象
      }
    }
  }
    
};
</script>

<style scoped>

.container {
  width: 100%;
}
.head{
  margin-left: 4px;
  margin-top: 20px;
  font-size: 20px;
  font-weight: bold;
}
.body{
  /* text-indent: 2em; */
  margin-left: 24px;
  font-size: 18px;
}


</style>
